<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'Contact-Worldwide Offices List',
          to: {
            name: 'ContactPage'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'OfficeCreate',
          }
        }
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>新增Office Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <OfficeCreateEdit></OfficeCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import OfficeCreateEdit from '@/views/B-6__Contact/c/OfficeCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    OfficeCreateEdit,
  },
  computed: {
    ...mapState('contact', ['contact']),
  },
  created() {
    this.setContact({});
  },
  methods: {
    ...mapActions('contact', ['setContact', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'ContactPage' });
    },
    saveHandler() {
      this.save(this.contact).then(() => {
        this.$router.push({ name: 'ContactPage' });
      });
    },
  },
};
</script>

<style></style>
